@if (engagementsList()?.length !== 0) {
    <div class="flex-table fixed-header w-100 bot-engagement-table" (click)="$event.stopPropagation()">
        <div class="flex-table-header">
            <p class="ft-cell ps-2 text-left des-cell">Client Name </p>
            <p class="ft-cell en-id-cell">Engagement ID</p>
            <p class="ft-cell year-date-cell">Year End
                @if (yearSort()?.iconClass) {
                    <button mat-button class="button-text ms-1" (click)="sortList('YEAR_END')">
                        <i [class]="yearSort()?.iconClass"></i>
                    </button>
                }
            </p>
            <p class="ft-cell status-cell">Status</p>
            <p class="ft-cell created-date-cell" style="padding-right:12px;">Date Created
                @if (dateSort()?.iconClass) {
                    <button mat-button class="button-text ms-1" (click)="sortList('CREATED_DATE')">
                        <i [class]="dateSort()?.iconClass"></i>
                    </button>
                }
            </p>
        </div>
    </div>

    <div class="flex-table fixed-header w-100 bot-engagement-table" (click)="$event.stopPropagation()"
         style="max-height: 400px; overflow-y: auto;">
        @for (eng of engagementsList(); track $index) {
            <button mat-menu-item class="ft-row button-row"
                    [ngClass]="{'eng-restricted': eng?.isRestricted }"
                    (click)="setSelectedEngagement($event,eng)">
                <p class="ft-cell ps-2 text-left des-cell" title="{{ eng?.clientName }}">
                    <span class="text-ellipse">{{ eng?.clientName }}</span>
                </p>
                <p class="ft-cell en-id-cell" title="{{ eng?.engName }}">
                    <span class="text-ellipse">{{ eng?.engName }}</span>
                </p>
                <p class="ft-cell year-date-cell">{{ eng?.yearEnd }}</p>
                <p class="ft-cell status-cell">
                    <span class="badge badge-small badge-pills badge-{{ eng?.engStatus }}">{{ eng?.engStatus }}</span>
                </p>
                <p class="ft-cell created-date-cell">{{ eng?.engCreatedDate | appCountableTimeZone: 'MMM dd, yyyy hh:mm a' }}</p>
            </button>
        }
    </div>
} @else {
    <div style="min-height:400px">
        <div class="no-data-found">
            <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
            <h6>No records found!</h6>
        </div>
    </div>
}

<ng-template #sessionManagement>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
        <span class="badge badge-error badge-circle icon-bordered-error text-center">
            <i class="fa-regular fa-circle-info"></i>
        </span>
            <h4 class="title text-center">Session Management</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>We Noticed you had a previous active session with LucaAI</p>
            <p>Would you like to 'Continue' with the recent active session or Start with 'New Session'</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-medium" color="dark"
                    [mat-dialog-close]="true">New Session
            </button>
            <button mat-button mat-flat-button class="button-medium" color="error"
                    [mat-dialog-close]="false">Continue
            </button>
        </div>
    </div>
</ng-template>
